<template>
    <div class="min-h-screen flex items-center justify-center bg-zinc-50 px-6">
        <div class="max-w-md text-center">
            <p class="text-slate-500 font-inter text-sm uppercase tracking-wide">Error {{ error.statusCode }}</p>
            <h1 class="mt-2 text-slate-700 font-inter font-bold text-2xl">Something went wrong</h1>
            <p class="mt-4 text-slate-600">{{ error.message }}</p>
            <button
                class="mt-8 inline-flex items-center justify-center rounded-md bg-blue-600 px-6 py-3 text-white-700 font-inter font-semibold text-sm"
                @click="handleError"
            >
                Try Again
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{ error: { statusCode: number; message: string } }>();

const handleError = () => clearError({ redirect: '/' });
</script>
